import * as THREE from 'three'

import { App } from "/App"
import { EventEmitter } from "/Utils/EventEmitter.js"


export class Renderer extends EventEmitter {
    constructor() {
        super()

        this.app = null
        this.instance = null

        this.resizeHandlerBound = this.resizeHandler.bind(this)

        this.init()
    }

    init() {
        this.app = new App()

        this.instance = new  THREE.WebGLRenderer({
            canvas : this.app.canvas,
            alpha: true,
            localClippingEnabled: true,
            antialias : true
        })

        this.instance.toneMapping = THREE.ACESFilmicToneMapping
        this.instance.toneMappingExposure = 0.9

        this.instance.outputColorSpace = THREE.SRGBColorSpace   

        this.instance.shadowMap.enabled = true
        this.instance.shadowMap.type = THREE.PCFSoftShadowMap

        if (this.app.debug.active) {
            const rf = this.app.debug.ui.addFolder('Renderer').close()

            rf.add(this.instance, 'toneMappingExposure', 0, 2, 0.01)
            rf.add(this.instance.shadowMap, 'enabled', false).name('shadows')
        }

        this.instance.setSize(this.app.renderSize.width, this.app.renderSize.height)
        this.instance.setPixelRatio(this.app.renderSize.pixelRatio)

        this.app.renderSize.on('resize', this.resizeHandlerBound)
    }

    resizeHandler(info) {
        this.instance.setSize(info.width, info.height)
        this.instance.setPixelRatio(info.pixelRatio)
    }

    render(scene, camera) {
        this.instance.render(scene, camera)
    }

    destroy() {
        this.app.renderSize.off('resize')
        this.resizeHandlerBound = null

        this.instance.dispose()
        this.instance = null
    }
}